import React from "react";
import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { validate } from "uuid";

const NewPassword: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name="new_password"
      label={t("new_password")}
      rules={[
        {
          required: true,
          message: t("required_message"),
        },
        {
          pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])(?!.*\s).{8,16}$/,
          message: t("password_rule"),
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const oldPassword = getFieldValue("oldPassword");
            if (!value) {
              return Promise.reject(new Error(t("New Password Required")));
            } else if (value === oldPassword) {
              return Promise.reject(
                new Error(t("confirm_password_cannot_be_old_password"))
              );
            }

            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input.Password />
    </Form.Item>
  );
};

export default NewPassword;
